import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OutbondIcon(props: IconProps) {
    return <Icon {...props} iconKey={"outbond"}/>
}
